import PosCartStore from '../../../stores/PosCartStore';
import UserStore from '../../../stores/UserStore';

import Price from '../../form/Price.react';
import Increase from '../selected/Increase.react';
import Decrease from '../selected/Decrease.react';
import InfoButton from '../selected/InfoButton.react';

class PosTypeSearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selected : false,
        };
    }

    render() {
        var guest               = this.props.guest;
        var qtyInCart           = false;
        var products            = _.cloneDeep(this.props.productList);
        let selected            = this.state.selected;
        let listKey             = this.props.listKey;
        let query               = this.props.query;
        let selectedLocation = UserStore.getState().selectedLocation;
        let hidePlusMinus = !selectedLocation.EnableSearchPlusMinus;

        var searchResults       = this.props.itemList.filter(x => {
            return (
                x.toLowerCase().indexOf(this.props.query.trim().toLowerCase()) >= 0
            );
        });

        if (this.state.selected) {
            products = _.filter(products, x => {
                return (
                    x[listKey].toLowerCase().indexOf(selected.trim().toLowerCase()) >= 0 &&
                    (!query.trim() ||  (
                                        x.ProductDesc.toLowerCase().indexOf(query.toLowerCase()) >= 0 ||
                                        x.ProductNo.toLowerCase().indexOf(query.toLowerCase()) >= 0 ||
                                        x.SerialNo.toLowerCase().indexOf(query.toLowerCase()) >= 0) )
                );
            });
        }

        return (<div>
            <div className='pos-search'>
                <div className='pos-search__content'>

                    <div className='pos-search__results'>

                        { this.state.selected &&
                            <div className='pos-search__strain'>
                                <i
                                    className='fa fa-angle-double-left'
                                    onClick={() => {
                                        this.setState({
                                            selected     : false,
                                        }, () => {
                                            this.props.onSearch(this.props.page, '');
                                        });
                                    }}
                                    style={{
                                        'marginRight' : 20,
                                        'cursor':'pointer',
                                    }} />
                                    {selected}
                            </div>
                        }

                        <div className='pos-search__header'>

                            <div className='pos-search__header--avail'>
                                Avail
                            </div>
                            <div className='pos-search__header--desc'>
                                Description
                            </div>
                        </div>

                        { !this.state.selected ?
                            searchResults.map((item, i) => {
                                return (
                                    <div
                                        className='by-strain'
                                        key={item.ProductCategory+'-'+i}
                                        onClick={() => {
                                            this.setState({
                                                selected: item,
                                            });
                                        }}>

                                        <div className='by-strain__block'>
                                            <div className='by-strain__category'>{item}</div>
                                        </div>
                                    </div>
                                );
                            })
                        :
                            products.slice(0, 500).map((item, i) => {
                                qtyInCart = PosCartStore.getQtyInCartBySerialNo(item.SerialNo);

                                return (
                                    <div
                                        className={'pos-search__item '+(i % 2 ? 'pos-search__item--grey' : '')}
                                        key={item.uuid}>

                                        <div className='pos-search__item--available'>
                                            {item.TotalAvailable}
                                        </div>

                                        <div className='pos-search__item--desc'>
                                            {item.ProductDesc}
                                        </div>

                                        <div className='pos-search__item--serial'>
                                            {item.SerialNo}
                                        </div>

                                        <div className='pos-search__item--price'>
                                            <Price price={item.UnitPrice} dollar={true} />
                                        </div>

                                        <div className='pos-search__item--weight'>
                                            {item.UnitGrams}g
                                        </div>

                                        { qtyInCart &&
                                            <div className='pos-search__item--qty'>
                                                {qtyInCart}
                                            </div>
                                        }

                                        <Increase
                                            item={item}
                                            guest={guest}
                                            page='search' 
                                            hide={hidePlusMinus}
                                        />

                                        <Decrease
                                            item={item}
                                            guest={guest}
                                            page='search'
                                            hide={hidePlusMinus}
                                        />

                                        <InfoButton
                                            item={item}
                                            guest={guest}
                                            page='search' />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            </div>
        );
    }
}

export default PosTypeSearch;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/search/PosTypeSearch.react.jsx